import { OnboardingLayout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";
import { useGetFundsRequestInfoQuery, useSpaNavigate } from "shared-ui";

import { useSubmitSubsequentFundingApplication } from "../../queries/funding-application/queries";

import { AdditionalFundingForm } from "./additional-funding-form";
import { MESSAGES } from "./message-definitions";

const FORM_ID = "additional-funding-form";

export const AdditionalFundingPage = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { isPending: isSubmitting } = useSubmitSubsequentFundingApplication(customerDomain);
  const { navigate } = useSpaNavigate("FundingApp");
  const { data: fundsRequestInfo } = useGetFundsRequestInfoQuery();

  const onCancel = () => {
    if (fundsRequestInfo?.alwaysOnOfferEnabled) {
      navigate(`/${customerDomain}/financing`);
    } else {
      navigate("/");
    }
  };

  return (
    <OnboardingLayout
      title={intl.formatMessage(MESSAGES.pageTitle)}
      formId={FORM_ID}
      primaryActionType="submit"
      actions={{
        primary: { content: intl.formatMessage(MESSAGES.submitButton), loading: isSubmitting, disabled: isSubmitting },
        secondary: {
          content: intl.formatMessage(MESSAGES.cancelButton),
          onAction: onCancel,
        },
      }}
    >
      <AdditionalFundingForm />
    </OnboardingLayout>
  );
};
